import Accordion from 'components/Accordion';
import Field from 'components/Form/Field';
import KeyValue from 'components/Layout/KeyValue';
import TextFragment from 'components/TextFragment';
import TooltipIcon from 'components/Tooltip/TooltipIcon';
import Value from 'components/Value';
import {
    SupersendContact,
    SupersendMessagePreview,
} from 'pages/History/SendingOrders/Details/types';
import {FC} from 'react';
import {t} from 'ttag';

type SendViaSecureSendProps = {
    isPasswordProtected: boolean;
    isSelected: boolean;
    messagePreview: SupersendMessagePreview;
    sendToContacts: SupersendContact[];
};

const SendViaSecureSend: FC<SendViaSecureSendProps> = ({
    isPasswordProtected,
    isSelected,
    messagePreview,
    sendToContacts,
}) => {
    if (!isSelected) return null;

    return (
        <Accordion
            header={
                <div className="flex items-center gap-2">
                    <h2 className="m-0 flex items-center gap-2 p-0">
                        {isPasswordProtected
                            ? t`Secure Send (Password Required)`
                            : t`Secure Send`}
                    </h2>
                    <TooltipIcon
                        href="https://help.makeleaps.jp/ja/articles/8687198-makeleapsのシステムから書類を送付する方法#h_7b3dac01e1"
                        message={t`What is Secure Send?`}
                        onClick={(e) => e.stopPropagation()}
                        size="base"
                    />
                </div>
            }
            hideDividerIfLast={true}
            id="send-via-securesend"
            isOpenByDefault={true}
        >
            <KeyValue className="text-base" keyWidth={10}>
                <Field
                    label={t`Send to`}
                    tooltip={{
                        href: 'https://help.makeleaps.jp/ja/articles/4108456-faq-セキュア送信を受け取るとどのように表示されますか',
                        message: t`Who receives emails when securely sending documents?`,
                    }}
                    type="value"
                >
                    {sendToContacts ? (
                        <Value
                            value={{
                                type: 'tags',
                                value: sendToContacts.map((recipient) => ({
                                    color: 'blue',
                                    label: recipient.name || '-',
                                    tooltip: recipient.email,
                                })),
                            }}
                        />
                    ) : (
                        <Value
                            value={{
                                type: 'string',
                                value: t`No Client Inbox Users set.`,
                            }}
                        />
                    )}
                </Field>
                <TextFragment
                    message={messagePreview.message}
                    subject={messagePreview.subject}
                    suffix={messagePreview.suffix}
                />
            </KeyValue>
        </Accordion>
    );
};

export default SendViaSecureSend;
